import PropTypes from "prop-types";

export default PropTypes.shape({
  statistics: PropTypes.shape({
    liveJobs: PropTypes.number,
    placements: PropTypes.number,
  }),
});
